import * as API from '@/services/API';

export default {
  getDesktop() {
    return API.apiClient.get(`/desktop`);
  }
};
